// extracted by mini-css-extract-plugin
export var alertIcon = "_ry-0";